import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./garageCustomization.initialState";
import { CustomizedGarage, CustomizedShutter, parkingPaymentDetails, parkingProductsType, SelectedQuoteType, UnitDetails } from "./garageCustomization.interface";

export const garageCustomizationSlice = createSlice({
  name: "garage-customization-slice",
  initialState,
  reducers: {
    updateCustomizedGarage: (
      state,
      action: PayloadAction<CustomizedGarage>
    ) => {
      state.customizedGarage = action.payload;
    },
    updateCustomizedShutter: (
      state,
      action: PayloadAction<CustomizedShutter>
    ) => {
      state.CustomizedShutter = action.payload;
    },
    updateParkingProducts: (
      state,
      action: PayloadAction<parkingProductsType>
    ) => {
      state.parkingProducts = action.payload;
    },

    parkingReferenceId: (state, action: PayloadAction<string>) => {
      state.parkingReferenceId = action.payload;
    },
    savedQuoteData: (state, action: PayloadAction<any>) => {
      state.savedQuoteData = action.payload;
    },
    defaultQuoteSelected: (state, action: PayloadAction<any>) => {
      state.defaultQuoteSelected = action.payload;
    },
    saveSelectedQuote : (state, action: PayloadAction<SelectedQuoteType>) => {
      state.selectedQuote = action.payload;
    },
    parkingPaymentDetails : (state, action: PayloadAction<parkingPaymentDetails>) => {
      state.parkingPaymentDetails = action.payload;
    },
    eligibleProperties : (state, action: PayloadAction<UnitDetails>) => {
      state.eligibleProperties = action.payload;
    },
    leadOpportunityId: (state, action: PayloadAction<string>) => {
      state.leadOpportunityId = action.payload;
    },
    clearCustomizedGarage: () => initialState,
  },
});

export const garageCustomizationActions = garageCustomizationSlice.actions;
export default garageCustomizationSlice.reducer;
